import { render, staticRenderFns } from "./BaseDetails.vue?vue&type=template&id=48bdb655&scoped=true&"
import script from "./BaseDetails.vue?vue&type=script&lang=js&"
export * from "./BaseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bdb655",
  null
  
)

export default component.exports